export const getLocaleFromSlug = (slug) => {
  if (slug === '/en' || slug.startsWith('/en/')) return 'en';
  if (slug === '/de' || slug.startsWith('/de/')) return 'de';
  if (slug === '/fr' || slug.startsWith('/fr/')) return 'fr';

  return 'nl';
};
